import type { AxiosResponse } from "axios";
import { productCacheTimestampAtom } from "../../../../legacy/stores/productCacheTimestamp/productCacheTimestamp.store";
import { globalStore } from "../../../../stores/global.store";

const CITIZEN_DATA_ENDPOINTS: RegExp[] = [
  /\/profile-data/,
  /\/households\/members/,
  /\/persona\//,
  /\/account/,
  /\/incomes\//,
  /\/real-estates\//,
  /\/isee\/type/,
  /\/survey\/[^/]+\/[^/]+\/next/,
];

const MUTATING_METHODS = new Set(["post", "patch", "delete", "put"]);

function isCitizenDataEndpoint(url: string): boolean {
  return CITIZEN_DATA_ENDPOINTS.some(function matchEndpoint(pattern) {
    return pattern.test(url);
  });
}

export function invalidateProductCacheOnCitizenDataMutation(response: AxiosResponse): AxiosResponse {
  const method = response.config.method?.toLowerCase();
  const url = response.config.url ?? "";
  const baseURL = response.config.baseURL ?? "";
  const fullUrl = baseURL + url;
  const isMutatingMethod = method !== undefined && MUTATING_METHODS.has(method);

  if (isMutatingMethod && (isCitizenDataEndpoint(url) || isCitizenDataEndpoint(fullUrl))) {
    globalStore.set(productCacheTimestampAtom, Date.now());
  }

  return response;
}
